// product.js — Phase 5 Yahoo 風

(function () {
  'use strict';

  const productForm = document.querySelector('[data-product-form]');
  const buyPanel = document.querySelector('.pdp-buy');
  const primaryCta = document.getElementById('primary-cta');
  const mainQty = document.getElementById('Quantity');
  const floatingCta = document.querySelector('[data-pdp-floating-cta]');
  const floatingQty = document.querySelector('[data-floating-qty]');
  const floatingAdd = document.querySelector('[data-floating-add]');
  const stickyCta = document.querySelector('[data-sticky-cta]');
  const stickyFavorite = document.querySelector('[data-sticky-fav]');
  const stickyAdd = document.querySelector('[data-sticky-cta-btn]');
  const reviewsSection = document.querySelector('[data-reviews-section]');
  const variantPills = document.querySelectorAll('.pdp-variant-pill');
  const variantSelect = document.querySelector('.pdp-variant-select');
  const productData = document.querySelector('[data-product-json]');
  const lowStockThreshold = parseInt((buyPanel && buyPanel.dataset.lowStockThreshold) || '5', 10);
  const reviewsLoaderSrc = reviewsSection ? reviewsSection.dataset.reviewsLoaderSrc || '' : '';
  let product = null;

  if (productData) {
    try {
      product = JSON.parse(productData.textContent);
    } catch (e) {
      product = null;
    }
  }

  function formatMoney(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function setElementHidden(el, shouldHide) {
    if (!el) return;
    el.hidden = !!shouldHide;
    el.classList.toggle('is-force-hidden', !!shouldHide);
  }

  function flashButtonLabel(button, html, duration) {
    if (!button) return;
    const originalHtml = button.dataset.originalHtml || button.innerHTML;
    button.dataset.originalHtml = originalHtml;
    button.innerHTML = html;
    window.setTimeout(function () {
      button.innerHTML = originalHtml;
    }, duration || 2000);
  }

  function scheduleDeferredTask(callback, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: timeout || 900 });
      return;
    }

    window.setTimeout(callback, timeout || 250);
  }

  function submitPrimaryProductForm() {
    if (productForm && typeof productForm.requestSubmit === 'function') {
      productForm.requestSubmit();
      return;
    }

    if (productForm) {
      productForm.submit();
      return;
    }

    if (primaryCta) {
      primaryCta.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function initBundleOffers() {
    document.querySelectorAll('.pdp-bundle').forEach(function (wrapper) {
      if (!wrapper || wrapper.dataset.bundleBound === 'true') return;
      wrapper.dataset.bundleBound = 'true';

      var checks = wrapper.querySelectorAll('.pdp-bundle-check');
      var totalEl = wrapper.querySelector('[data-bundle-total-value]');
      var addBtn = wrapper.querySelector('[data-bundle-add]');
      var feedbackEl = wrapper.querySelector('[data-bundle-feedback]');

      if (!checks.length || !totalEl || !addBtn) return;

      function recalc() {
        var total = 0;
        checks.forEach(function (check) {
          if (!check.checked) return;
          total += parseInt(check.dataset.bundlePrice || '0', 10);
        });
        totalEl.textContent = formatMoney(total);
      }

      checks.forEach(function (check) {
        check.addEventListener('change', recalc);
      });

      addBtn.addEventListener('click', function () {
        var items = [];

        if (feedbackEl) {
          feedbackEl.hidden = true;
          feedbackEl.textContent = '';
        }

        checks.forEach(function (check) {
          if (!check.checked) return;
          items.push({
            id: parseInt(check.dataset.bundleVariant || '0', 10),
            quantity: 1
          });
        });

        if (!items.length) return;

        addBtn.disabled = true;
        addBtn.innerHTML = '<span class="ms sm" aria-hidden="true">hourglass_empty</span> 追加中...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('cart add failed');
            }
            window.location.href = '/cart';
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.innerHTML = '<span class="ms sm fill" aria-hidden="true">shopping_cart</span> カートに入れる';
            if (feedbackEl) {
              feedbackEl.textContent = '追加できませんでした。在庫状況をご確認のうえ、時間をおいてお試しください。';
              feedbackEl.hidden = false;
            }
          });
      });

      recalc();
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function safeHref(value) {
    var raw = String(value || '').trim();
    if (!raw) return '#';
    try {
      var url = new URL(raw, window.location.origin);
      if (url.origin !== window.location.origin) return '#';
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return '#';
      return url.pathname + url.search + url.hash;
    } catch (error) {
      void error;
      return raw.charAt(0) === '/' && raw.charAt(1) !== '/' ? raw : '#';
    }
  }

  function normalizeImageUrl(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function isMerchOnlyProduct(item) {
    var title = String(item && item.title || '').toLowerCase();
    var type = String(item && item.type || '').toLowerCase();
    var tags = Array.isArray(item && item.tags) ? item.tags.join(' ').toLowerCase() : '';
    return (
      title.indexOf('ショッピングバッグ') !== -1 ||
      title.indexOf('紙袋') !== -1 ||
      title.indexOf('ビニール') !== -1 ||
      title.indexOf('数量ご選択下さい') !== -1 ||
      title.indexOf('ラッピング') !== -1 ||
      title.indexOf('ギフトオプション') !== -1 ||
      type.indexOf('ラッピング') !== -1 ||
      type.indexOf('ギフト') !== -1 ||
      type.indexOf('包装') !== -1 ||
      tags.indexOf('ラッピング') !== -1 ||
      tags.indexOf('包装') !== -1 ||
      tags.indexOf('ギフトオプション') !== -1
    );
  }

  function toPriceCents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') return Math.round(value);
    var raw = String(value).replace(/[^\d.]/g, '');
    if (!raw) return 0;
    return Math.round(parseFloat(raw) * 100);
  }

  function firstAvailableVariant(item) {
    var variants = Array.isArray(item && item.variants) ? item.variants : [];
    return variants.find(function (variant) { return variant && variant.available; }) || null;
  }

  function bundleImageUrl(item) {
    if (!item) return '';
    if (item.featured_image) return item.featured_image;
    if (item.image) return item.image;
    if (Array.isArray(item.images) && item.images[0]) {
      return item.images[0].src || item.images[0];
    }
    return '';
  }

  function normalizeBundleProduct(item) {
    var variant = firstAvailableVariant(item);
    if (!item || !variant || !variant.id) return null;
    var handle = String(item.handle || '').trim();
    var title = String(item.title || '').trim();
    if (!handle || !title) return null;

    return {
      id: String(item.id || ''),
      handle: handle,
      title: title,
      url: safeHref(item.url || ('/products/' + handle)),
      available: true,
      variants: [{ id: variant.id, available: true }],
      price: toPriceCents(variant.price != null ? variant.price : item.price),
      featured_image: bundleImageUrl(item),
      type: item.type,
      tags: item.tags
    };
  }

  function fetchBundleProducts(endpoint) {
    return fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('bundle source failed');
        return response.json();
      })
      .then(function (data) {
        return Array.isArray(data.products) ? data.products : [];
      })
      .catch(function () {
        return [];
      });
  }

  function buildBundleVisualCard(item) {
    var title = item.title;
    var image = normalizeImageUrl(item.image || item.featured_image || '');
    var price = formatMoney(parseInt(item.price || 0, 10));
    var imageHtml = image
      ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.title) + '" width="128" height="128" class="pdp-bundle-item-img" loading="lazy">'
      : '<div class="pdp-bundle-item-img pdp-bundle-item-img--placeholder" aria-hidden="true"><span class="ms" aria-hidden="true">inventory_2</span></div>';

    return (
      '<div class="pdp-bundle-visual-card">' +
        '<div class="pdp-bundle-item">' + imageHtml + '</div>' +
        '<div class="pdp-bundle-mini-title">' + escapeHtml(title) + '</div>' +
        '<div class="pdp-bundle-mini-price">' + escapeHtml(price) + '</div>' +
      '</div>'
    );
  }

  function initDynamicBundleOffers() {
    var shells = Array.from(document.querySelectorAll('[data-dynamic-bundle]'));
    if (!shells.length) return Promise.resolve();

    return Promise.all(shells.map(function (shell) {
      var productId = shell.dataset.productId;
      var currentHandle = (shell.dataset.currentHandle || '').trim();
      var currentTitle = (shell.dataset.currentTitle || '').trim();
      var fallbackCollections = (shell.dataset.fallbackCollections || '')
        .split(',')
        .map(function (handle) { return handle.trim(); })
        .filter(Boolean)
        .slice(0, 4);
      var visual = shell.querySelector('[data-dynamic-bundle-visual]');
      var list = shell.querySelector('[data-dynamic-bundle-list]');

      function hideShell() {
        shell.hidden = true;
        var parent = shell.closest('.pdp-top-extras');
        if (parent) parent.hidden = true;
      }

      function showShell() {
        shell.hidden = false;
        shell.removeAttribute('hidden');
        var parent = shell.closest('.pdp-top-extras');
        if (parent) parent.hidden = false;
        if (parent) parent.removeAttribute('hidden');
      }

      if (!productId || !visual || !list) return Promise.resolve();

      var endpoints = [
        '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=8&intent=related'
      ];
      fallbackCollections.forEach(function (handle) {
        endpoints.push('/collections/' + encodeURIComponent(handle) + '/products.json?limit=18');
      });
      endpoints.push('/collections/all/products.json?limit=32');

      return Promise.all(endpoints.map(fetchBundleProducts))
        .then(function (groups) {
          var seen = {};
          var picks = [];

          groups.forEach(function (items) {
            items.forEach(function (rawItem) {
              if (picks.length >= 2) return;
              var item = normalizeBundleProduct(rawItem);
              if (!item) return;
              var isCurrentProduct =
                String(item.id || '') === String(productId || '') ||
                (currentHandle && item.handle === currentHandle) ||
                (currentTitle && item.title === currentTitle) ||
                (item.handle && window.location.pathname.indexOf('/products/' + item.handle) !== -1);
              if (isCurrentProduct || isMerchOnlyProduct(item) || seen[item.id || item.handle]) return;
              seen[item.id || item.handle] = true;
              picks.push(item);
            });
          });

          if (!picks.length) {
            hideShell();
            return;
          }

          var visualCards = picks.map(function (item, index) {
              var plus = index > 0 ? '<span class="pdp-bundle-plus" aria-hidden="true">+</span>' : '';
              return plus + buildBundleVisualCard({
                title: item.title,
                image: item.featured_image,
                price: item.price
              });
            }).join('');

          visual.innerHTML = visualCards;

          var listHtml = picks.map(function (item) {
              var variant = item.variants[0];
              return '<li class="pdp-bundle-list-item"><label>' +
                '<input type="checkbox" class="pdp-bundle-check" data-bundle-variant="' + variant.id + '" data-bundle-price="' + item.price + '" checked>' +
                '<span class="pdp-bundle-list-title"><a href="' + escapeHtml(safeHref(item.url || ('/products/' + item.handle))) + '">' + escapeHtml(item.title) + '</a></span>' +
                '<span class="pdp-bundle-list-price">' + escapeHtml(formatMoney(item.price)) + '</span>' +
              '</label></li>';
            }).join('');
          list.innerHTML = listHtml;

          showShell();
          shell.dataset.bundleBound = 'false';
        })
        .catch(function () {
          hideShell();
        });
    })).then(function () {
      initBundleOffers();
    });
  }

  function toggleStrike(compareAtPrice, price) {
    const strikeValue = compareAtPrice && compareAtPrice > price ? formatMoney(compareAtPrice) : '';
    document.querySelectorAll('.pdp-price-strike, .pdp-floating-cta-strike, .pdp-sticky-cta-strike').forEach(function (el) {
      if (!el) return;
      if (strikeValue) {
        el.textContent = strikeValue;
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });

    const offPctEl = document.querySelector('.pdp-price-off');
    const offBadgeEl = document.querySelector('.off-badge');
    if (strikeValue) {
      const offPct = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
      if (offPctEl) {
        offPctEl.textContent = '-' + offPct + '%';
        offPctEl.hidden = false;
      }
      if (offBadgeEl) {
        offBadgeEl.innerHTML = offPct + '%<small>OFF</small>';
        offBadgeEl.hidden = false;
      }
    } else {
      if (offPctEl) offPctEl.hidden = true;
      if (offBadgeEl) offBadgeEl.hidden = true;
    }
  }

  function syncStock(matched) {
    const stockLabel = document.querySelector('.pdp-buy-stock');
    const urgencyBox = document.querySelector('[data-stock-box], .pdp-stock-low, .pdp-stock-out');
    const managed = !!matched.inventory_management;
    const qty = parseInt(matched.inventory_quantity || '0', 10);
    const isSoldOut = managed && matched.inventory_policy !== 'continue' && qty <= 0;
    const isLowStock = managed && matched.inventory_policy !== 'continue' && qty > 0 && qty <= lowStockThreshold;

    if (stockLabel) {
      stockLabel.classList.toggle('is-low', isSoldOut || isLowStock);
      if (isSoldOut) {
        stockLabel.hidden = false;
        stockLabel.innerHTML = '<span class="ms sm fill" aria-hidden="true">cancel</span>在庫切れ';
      } else if (isLowStock) {
        stockLabel.hidden = true;
      } else {
        stockLabel.hidden = false;
        stockLabel.innerHTML = '<span class="ms sm fill" aria-hidden="true">check_circle</span>在庫あり';
      }
    }

    if (urgencyBox) {
      if (isSoldOut) {
        urgencyBox.hidden = true;
      } else if (isLowStock) {
        urgencyBox.hidden = false;
        urgencyBox.classList.remove('pdp-stock-out');
        urgencyBox.classList.add('pdp-stock-low');
        urgencyBox.setAttribute('role', 'status');
        urgencyBox.setAttribute('aria-live', 'polite');
        urgencyBox.innerHTML =
          '<div class="pdp-stock-low-head">' +
            '<span class="pdp-stock-low-flag"><span class="ms sm fill" aria-hidden="true">check_circle</span>在庫あり</span>' +
            '<strong>残り' + qty + '点</strong>' +
          '</div>';
      } else {
        urgencyBox.hidden = true;
      }
    }
  }

  function applyVariant(matched) {
    const hiddenInput = productForm && productForm.querySelector('input[name="id"]');
    if (hiddenInput) hiddenInput.value = matched.id;

    const priceEl = document.getElementById('primary-cta-price');
    if (priceEl && matched.price != null) {
      priceEl.textContent = formatMoney(matched.price);
    }
    document.querySelectorAll('.pdp-floating-cta-price strong, .pdp-sticky-cta-price strong').forEach(function (el) {
      el.textContent = formatMoney(matched.price);
    });
    toggleStrike(matched.compare_at_price, matched.price);

    const cartBtn = document.getElementById('primary-cta');
    const qtyRow = document.querySelector('[data-qty-row]');
    const notifyBtn = document.querySelector('[data-notify-primary]');
    const floatingQtyWrap = document.querySelector('[data-floating-qty-wrap]');
    const floatingBtn = document.querySelector('[data-floating-add]');
    if (cartBtn) {
      if (matched.available) {
        setElementHidden(cartBtn, false);
        cartBtn.disabled = false;
        cartBtn.innerHTML = '<span class="ms md fill" aria-hidden="true">shopping_cart</span>カートに入れる';
      } else {
        setElementHidden(cartBtn, true);
        cartBtn.disabled = true;
      }
    }
    setElementHidden(qtyRow, !matched.available);
    setElementHidden(notifyBtn, matched.available);
    setElementHidden(floatingQtyWrap, !matched.available);

    if (floatingBtn) {
      if (matched.available) {
        if (floatingCta) floatingCta.dataset.mode = 'cart';
        floatingBtn.dataset.mode = 'cart';
        floatingBtn.disabled = false;
        floatingBtn.innerHTML = '<span class="ms sm fill" aria-hidden="true">shopping_cart</span>カートに入れる';
      } else {
        if (floatingCta) floatingCta.dataset.mode = 'notify';
        floatingBtn.dataset.mode = 'notify';
        floatingBtn.disabled = false;
        floatingBtn.innerHTML = '<span class="ms sm" aria-hidden="true">notifications</span>再入荷通知を受け取る';
      }
    }

    document.querySelectorAll('[data-sticky-cta-btn]').forEach(function (btn) {
      btn.disabled = !matched.available;
    });

    syncStock(matched);

    if (matched.featured_image) {
      const mainImg = document.querySelector('.pdp-img-main img');
      if (mainImg && matched.featured_image.src) {
        mainImg.src = matched.featured_image.src;
        mainImg.srcset = '';
      }
    }
  }

  function findVariantByOptions(selectedOptions) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
    }) || null;
  }

  function findVariantById(id) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (v) {
      return String(v.id) === String(id);
    }) || null;
  }

  // Pill 選択
  variantPills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (this.classList.contains('is-disabled')) return;

      const group = this.closest('.pdp-variant-pills');
      if (group) {
        group.querySelectorAll('.pdp-variant-pill').forEach(function (p) {
          p.classList.remove('is-selected');
        });
      }
      this.classList.add('is-selected');

      const groups = document.querySelectorAll('.pdp-variant-pills');
      const selectedOptions = Array.from(groups).map(function (g) {
        const selected = g.querySelector('.is-selected');
        return selected
          ? (selected.dataset.optionValue || selected.textContent.trim())
          : null;
      }).filter(Boolean);

      const matched = findVariantByOptions(selectedOptions);
      if (matched) applyVariant(matched);
    });
  });

  // Dropdown 選択
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const matched = findVariantById(this.value);
      if (matched) applyVariant(matched);
    });
  }

  if (mainQty && floatingQty) {
    floatingQty.value = mainQty.value;

    mainQty.addEventListener('change', function () {
      floatingQty.value = mainQty.value;
    });
    mainQty.addEventListener('input', function () {
      floatingQty.value = mainQty.value;
    });

    floatingQty.addEventListener('change', function () {
      mainQty.value = floatingQty.value;
    });
    floatingQty.addEventListener('input', function () {
      mainQty.value = floatingQty.value;
    });
  }

  if (floatingAdd && productForm) {
    floatingAdd.addEventListener('click', function () {
      if (this.dataset.mode === 'notify') {
        if (this.dataset.contactUrl) {
          window.location.href = this.dataset.contactUrl;
          return;
        }
        flashButtonLabel(this, '<span class="ms sm" aria-hidden="true">mail</span>お問い合わせからご相談ください', 2500);
        return;
      }
      if (mainQty && floatingQty) {
        mainQty.value = floatingQty.value;
      }
      submitPrimaryProductForm();
    });
  }

  if (product) {
    const hiddenInput = productForm && productForm.querySelector('input[name="id"]');
    const initialVariant =
      findVariantById(hiddenInput && hiddenInput.value) ||
      findVariantById(variantSelect && variantSelect.value) ||
      product.variants.find(function (variant) { return variant.available; }) ||
      product.variants[0];

    if (initialVariant) {
      applyVariant(initialVariant);
    }
  }

  initBundleOffers();
  initDynamicBundleOffers();

  if (
    floatingCta &&
    primaryCta &&
    'IntersectionObserver' in window &&
    (!window.matchMedia || window.matchMedia('(min-width: 769px)').matches)
  ) {
    let floatingBlocked = false;
    let primaryVisible = true;
    let floatingBlockerFrame = 0;
    const floatingBlockers = Array.from(document.querySelectorAll('[data-cart-drawer], .cart-drawer, .mini-cart-drawer'));

    const applyFloatingState = function () {
      const shouldHide = window.innerWidth <= 768 || primaryVisible || floatingBlocked;
      floatingCta.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
    };

    const isFloatingBlockerActive = function (blocker) {
      if (!blocker || blocker.hidden || blocker.getAttribute('aria-hidden') === 'true') return false;
      const style = window.getComputedStyle(blocker);
      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        style.pointerEvents === 'none' ||
        Number(style.opacity) === 0
      ) {
        return false;
      }
      const rect = blocker.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight - 24 && rect.bottom > 24;
    };

    const syncFloatingVisibility = function (isVisible) {
      if (window.innerWidth <= 768) {
        primaryVisible = true;
        applyFloatingState();
        return;
      }
      primaryVisible = isVisible;
      applyFloatingState();
    };

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        syncFloatingVisibility(entry.isIntersecting);
      });
    }, {
      rootMargin: '-80px 0px -10% 0px',
      threshold: 0.15
    });

    observer.observe(primaryCta);

    const syncFloatingBlockers = function () {
      if (window.innerWidth <= 768) {
        floatingBlocked = false;
        applyFloatingState();
        return;
      }

      floatingBlocked = floatingBlockers.some(function (blocker) {
        return isFloatingBlockerActive(blocker);
      });

      applyFloatingState();
    };

    const scheduleFloatingBlockers = function () {
      if (floatingBlockerFrame) return;
      floatingBlockerFrame = window.requestAnimationFrame(function () {
        floatingBlockerFrame = 0;
        syncFloatingBlockers();
      });
    };

    if (floatingBlockers.length) {
      syncFloatingBlockers();
    }

    window.addEventListener('scroll', scheduleFloatingBlockers, { passive: true });
    window.addEventListener('resize', function () {
      const rect = primaryCta.getBoundingClientRect();
      const isVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      syncFloatingVisibility(isVisible);
      scheduleFloatingBlockers();
    });

    syncFloatingBlockers();
  }

  if (stickyCta && primaryCta && 'IntersectionObserver' in window) {
    const syncStickyVisibility = function (isVisible) {
      if (window.innerWidth > 768) {
        stickyCta.hidden = true;
        stickyCta.setAttribute('aria-hidden', 'true');
        return;
      }

      stickyCta.hidden = !!isVisible;
      stickyCta.setAttribute('aria-hidden', isVisible ? 'true' : 'false');
    };

    const stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        syncStickyVisibility(entry.isIntersecting);
      });
    }, {
      rootMargin: '-100px 0px 0px 0px',
      threshold: 0
    });

    stickyObserver.observe(primaryCta);

    window.addEventListener('resize', function () {
      const rect = primaryCta.getBoundingClientRect();
      const isVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      syncStickyVisibility(isVisible);
    });
  }

  if (stickyAdd) {
    stickyAdd.addEventListener('click', function () {
      submitPrimaryProductForm();
    });
  }

  // 画像ギャラリー切替 (thumb クリック)
  const thumbRail = document.querySelector('.pdp-img-thumbs');
  const mainImg = document.querySelector('.pdp-img-main img');
  let thumbs = Array.from(document.querySelectorAll('.pdp-thumb[data-media-id]'));

  function syncActiveThumb(nextActive) {
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb === nextActive);
      thumb.setAttribute('aria-pressed', thumb === nextActive ? 'true' : 'false');
    });
  }

  function setMainImageFromThumb(thumb) {
    if (!thumb || !mainImg) return;
    const thumbImg = thumb.querySelector('img');
    const fullSrc = thumb.dataset.fullSrc || (thumbImg && (thumbImg.currentSrc || thumbImg.src));
    const fullSrcset = thumb.dataset.fullSrcset || '';
    if (!fullSrc) return;
    mainImg.src = fullSrc;
    if (fullSrcset) {
      mainImg.srcset = fullSrcset;
    } else {
      mainImg.removeAttribute('srcset');
    }
    syncActiveThumb(thumb);
  }

  function pruneThumbRail() {
    if (!thumbRail) return;

    thumbs = Array.from(thumbRail.querySelectorAll('.pdp-thumb[data-media-id]')).filter(function (thumb) {
      const thumbImg = thumb.querySelector('img');
      const src = thumbImg && (thumbImg.currentSrc || thumbImg.getAttribute('src'));
      const hasRenderableImage = !!src;

      if (!hasRenderableImage) {
        thumb.remove();
        return false;
      }

      if (thumbImg.complete && (thumbImg.naturalWidth === 0 || thumbImg.naturalHeight === 0)) {
        thumb.remove();
        return false;
      }

      thumb.setAttribute('aria-pressed', thumb.classList.contains('is-active') ? 'true' : 'false');
      return true;
    });

    if (thumbs.length <= 1) {
      thumbRail.hidden = true;
      return;
    }

    thumbRail.hidden = false;

    const activeThumb = thumbs.find(function (thumb) {
      return thumb.classList.contains('is-active');
    }) || thumbs[0];

    syncActiveThumb(activeThumb);
  }

  thumbs.forEach(function (thumb) {
    const thumbImg = thumb.querySelector('img');
    if (thumbImg) {
      thumbImg.addEventListener('error', function () {
        thumb.remove();
        pruneThumbRail();
      });
      if (!thumbImg.complete) {
        thumbImg.addEventListener('load', pruneThumbRail, { once: true });
      }
    }

    thumb.addEventListener('click', function () {
      setMainImageFromThumb(this);
    });
  });

  pruneThumbRail();

  scheduleDeferredTask(function () {
    // お気に入り (localStorage)
    const WISHLIST_KEY = 'theme_wishlist';
    const wishlistBtn = document.querySelector('[data-wishlist-btn]');
    const wishlistBadge = document.querySelector('[data-wishlist-badge]');

    function getWishlist() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
      catch (e) { return []; }
    }
    function saveWishlist(arr) {
      try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr)); }
      catch (e) { /* ignore */ }
    }
    function updateWishlistBadge() {
      if (!wishlistBadge) return;
      const count = getWishlist().length;
      if (count > 0) {
        wishlistBadge.textContent = count;
        wishlistBadge.hidden = false;
      } else {
        wishlistBadge.hidden = true;
      }
    }

    function setWishlistButtonState(btn, selected) {
      if (!btn) return;
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      btn.setAttribute('aria-label', selected ? 'お気に入りから外す' : 'お気に入りに追加');
      btn.innerHTML = selected
        ? '<span class="ms md fill" aria-hidden="true">favorite</span>'
        : '<span class="ms md" aria-hidden="true">favorite_border</span>';
    }

    function toggleWishlist(handle, btn) {
      if (!handle) return;
      let list = getWishlist();
      const selected = list.includes(handle);
      if (selected) {
        list = list.filter(function (h) { return h !== handle; });
      } else {
        list.unshift(handle);
        if (list.length > 100) list = list.slice(0, 100);
      }
      saveWishlist(list);
      updateWishlistBadge();
      setWishlistButtonState(btn, !selected);
    }

    updateWishlistBadge();

    if (wishlistBtn) {
      const handle = wishlistBtn.dataset.productHandle;
      const list = getWishlist();
      if (list.includes(handle)) {
        wishlistBtn.innerHTML = '<span class="ms sm fill" aria-hidden="true">favorite</span>お気に入り登録済';
      }

      wishlistBtn.addEventListener('click', function () {
        let list = getWishlist();
        if (list.includes(handle)) {
          list = list.filter(function (h) { return h !== handle; });
          this.innerHTML = '<span class="ms sm" aria-hidden="true">favorite_border</span>お気に入り登録';
        } else {
          list.unshift(handle);
          if (list.length > 100) list = list.slice(0, 100);
          this.innerHTML = '<span class="ms sm fill" aria-hidden="true">favorite</span>お気に入り登録済';
        }
        saveWishlist(list);
        updateWishlistBadge();
      });
    }

    if (stickyFavorite) {
      const stickyHandle = stickyFavorite.dataset.productHandle || (wishlistBtn && wishlistBtn.dataset.productHandle);
      setWishlistButtonState(stickyFavorite, stickyHandle ? getWishlist().includes(stickyHandle) : false);

      stickyFavorite.addEventListener('click', function () {
        toggleWishlist(stickyHandle, this);
      });
    }

    if (reviewsSection && reviewsLoaderSrc) {
      window.__happydeersReviewsSectionLoaderPresent = true;
    }

    // 商品共有: native shareに丸投げせず、共有先を選べるメニューとして提示する。
    function sharePayload() {
      const titleEl = document.querySelector('.pdp-title');
      const title = ((titleEl && titleEl.textContent) || document.title || '').replace(/\s+/g, ' ').trim();
      const url = window.location.href.split('#')[0];
      return {
        title: title || document.title,
        url: url
      };
    }

    function copyShareUrl(url) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(url);
      }

      return new Promise(function (resolve, reject) {
        const textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          if (document.execCommand('copy')) {
            resolve();
          } else {
            reject(new Error('copy failed'));
          }
        } catch (error) {
          reject(error);
        } finally {
          document.body.removeChild(textarea);
        }
      });
    }

    function setShareStatus(root, message, isError) {
      const status = root && root.querySelector('[data-share-status]');
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', !!isError);
    }

    function updateShareLinks(root) {
      const data = sharePayload();
      const encodedUrl = encodeURIComponent(data.url);
      const encodedTitle = encodeURIComponent(data.title);
      const encodedBody = encodeURIComponent(data.title + '\n' + data.url);

      root.querySelectorAll('[data-share-channel]').forEach(function (link) {
        const channel = link.dataset.shareChannel;
        if (channel === 'line') {
          link.href = 'https://social-plugins.line.me/lineit/share?url=' + encodedUrl;
        } else if (channel === 'x') {
          link.href = 'https://twitter.com/intent/tweet?text=' + encodedTitle + '&url=' + encodedUrl;
        } else if (channel === 'facebook') {
          link.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl;
        } else if (channel === 'mail') {
          link.href = 'mailto:?subject=' + encodedTitle + '&body=' + encodedBody;
        }
      });
    }

    function toggleSharePanel(root, shouldOpen) {
      const panel = root && root.querySelector('[data-share-panel]');
      const trigger = root && root.querySelector('[data-share-trigger]');
      if (!panel || !trigger) return;

      if (shouldOpen) {
        updateShareLinks(root);
        setShareStatus(root, '');
      }

      panel.hidden = !shouldOpen;
      root.classList.toggle('is-open', !!shouldOpen);
      trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    }

    function closeSharePanels(exceptRoot) {
      document.querySelectorAll('[data-share-root]').forEach(function (root) {
        if (root !== exceptRoot) toggleSharePanel(root, false);
      });
    }

    document.querySelectorAll('[data-share-root]').forEach(function (root) {
      const trigger = root.querySelector('[data-share-trigger]');
      const closeBtn = root.querySelector('[data-share-close]');
      const copyBtn = root.querySelector('[data-share-copy]');
      const nativeBtn = root.querySelector('[data-share-native]');

      if (nativeBtn) {
        nativeBtn.hidden = !navigator.share;
      }

      if (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          const panel = root.querySelector('[data-share-panel]');
          const willOpen = panel ? panel.hidden : true;
          closeSharePanels(root);
          toggleSharePanel(root, willOpen);
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          toggleSharePanel(root, false);
        });
      }

      root.querySelectorAll('[data-share-channel]').forEach(function (link) {
        link.addEventListener('click', function () {
          updateShareLinks(root);
        });
      });

      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          const data = sharePayload();
          copyShareUrl(data.url).then(function () {
            setShareStatus(root, '商品URLをコピーしました。', false);
          }).catch(function () {
            setShareStatus(root, 'コピーできませんでした。URLを選択してコピーしてください。', true);
          });
        });
      }

      if (nativeBtn) {
        nativeBtn.addEventListener('click', async function () {
          if (!navigator.share) return;
          try {
            await navigator.share(sharePayload());
            setShareStatus(root, '共有メニューを開きました。', false);
          } catch (error) {
            void error;
          }
        });
      }
    });

    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-share-root]')) return;
      closeSharePanels();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSharePanels();
    });

    // 再入荷通知
    document.querySelectorAll('[data-back-in-stock]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.dataset.contactUrl) {
          window.location.href = this.dataset.contactUrl;
          return;
        }
        flashButtonLabel(this, '<span class="ms sm" aria-hidden="true">mail</span>お問い合わせからご相談ください', 2500);
      });
    });

  }, 1200);
})();
